import React, { useState, useEffect } from 'react';
import { getDefaultThumbnailUrl } from '../../utils/thumbnailUtils';
import { ThumbnailImageProps } from './types';

/**
 * サムネイル画像表示用のコンポーネント
 * 画像の読み込みを非同期で行い、読み込み完了時に表示します
 * エラー時はデフォルトサムネイルを表示します
 */
export const ThumbnailImage: React.FC<ThumbnailImageProps> = ({ src, alt, className }) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [hasError, setHasError] = useState<boolean>(false);
  
  useEffect(() => {
    if (!src) {
      setHasError(true);
      return;
    }
    
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setImageSrc(src);
      setHasError(false);
    };
    img.onerror = () => {
      setHasError(true);
      setImageSrc(null);
    };
  }, [src]);
  
  return (
    <img 
      src={hasError ? getDefaultThumbnailUrl() : (imageSrc || getDefaultThumbnailUrl())}
      alt={alt}
      className={className}
      data-testid="video-card-mobile__thumbnail"
      onError={() => setHasError(true)}
    />
  );
}; 
